import { useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { IndexTemplate, TableView } from "../../../commons/components";
import { Page } from "../../../commons/services";
import { usuarioPolicy } from "../policies";
import { useGetUsuariosQuery } from "../usuariosApi";
import { RowOptions } from "./RowOptions";

export function UsuarioIndex() {
  const [page, setPage] = useState<Page>({
    current: 1,
    size: 10
  })

  const buscar = useGetUsuariosQuery({
    page
  })
  const isRefetching = !buscar.isLoading && buscar.isFetching

  return <>
    <Breadcrumb>
      <Breadcrumb.Item active>Usuarios</Breadcrumb.Item>
    </Breadcrumb>
    <IndexTemplate
      total={buscar.data?.meta.totalRecords ?? -1}
      onPageChange={setPage}
      onRefetch={buscar.refetch}
      registerPath="registrar"
      policy={usuarioPolicy}
      renderView={()=>{
        return <TableView
          expectedLength={page.size}
          data={isRefetching ? undefined : buscar.currentData?.records}
          isLoading={buscar.isFetching}
          hasError={buscar.isError}
          renderHeaders={()=><tr>
            <th style={{width: 0}}>#</th>
            <th className="text-nowrap">Nombre de usuario</th>
            <th className="text-nowrap">Correo electrónico</th>
            <th>Estado</th>
            <th style={{width: 0}}></th>
          </tr>}
          renderRow={(item, index)=><tr key={item?.id || index}>
            <th scope="row">{(page.current - 1)*page.size + index + 1}</th>
            <td>{item ? item.username : <Skeleton />}</td>
            <td>{item ? item.email : <Skeleton />}</td>
            <td>{item ? {1: "Activo", 2: "Inactivo"}[item.estado] : <Skeleton />}</td>
            <td>{item ? <RowOptions usuario={item} /> : null}</td>
          </tr>}
        />
      }}
    />
  </>
}